@if ((filteredProducts$ | async)?.length) {
  <section class="section-outset-y container content-block-featured-products">
    @if (block.featuredProducts) {
      <ul class="row product-list" [class.set--default]="(filteredProducts$ | async)!.length < 4">
        @for (product of filteredProducts$ | async; track product.id; let i = $index) {
          <li
            class="content-block-featured-products__list__item col-6"
            [ngClass]="(filteredProducts$ | async)!.length > 3 ? 'col-md-3' : 'col-md-4'"
          >
            <app-product-card
              [sizes]="{ xs: 6, md: 2, lg: 1 }"
              [productPreview]="product"
              [product]="(products$ | async)?.[i]"
              [showSlider]="true"
            ></app-product-card>
          </li>
        }
      </ul>
    }
    @if (block.button && block.button.url) {
      <div class="text-center mt-2">
        <fstr-link [cssClasses]="'button button--secondary button-outline'" [button]="block.button"></fstr-link>
      </div>
    }
  </section>
}
